import * as React from 'react'
import styled from 'styled-components'

import Layout from '../../../../components/ui/Layout/Layout'
import Spinner from '../../../../components/ui/Spinner/Spinner'
import { doRequestSSOCode, doVerifyToken } from '../../../../controllers/Login'
import { deleteAccessToken } from '../../../../services/data/accessToken'
import {
  getCredentials,
  setSSOVerification,
  getSSOData,
  deleteSSOData,
  // getRedirectUri,
  // getSSOToken,
  // getResponseType,
  // decodeSSOData,
} from '../../../../services/data/sso'

const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled.h1`
  font-size: 1.5rem;
  text-align: center;
  margin-top: 0;
  color: var(--color-secondary);
  font-weight: var(--font-weight-bold);
`

const SpinnerContainer = styled.div`
  text-align: center;
  margn: 3rem;
`

const ErrorContainer = styled.div`
  position: relative;
`

const ErrorMessage = styled.div`
  border: 1px solid var(--color-error);
  border-radius: var(--border-radius-form);
  padding: 0.5rem 1rem;
  text-align: center;
  &::before {
    content: ' ';
    display: block;
    border-radius: var(--border-radius-form);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--color-error);
    opacity: 0.1;
  }
`

function MainView({ location = {}, doVerifyClient, replace }) {
  const [loading, setLoading] = React.useState(true)
  const [errorMessage, setErrorMessage] = React.useState('')

  const redirectToLogin = async ({ redirectUri, responseType, clientId }) => {
    await setSSOVerification(true)
    replace(
      `/login?redirectUri=${encodeURIComponent(
        redirectUri,
      )}&responseType=${responseType}&clientId=${clientId}`,
    )
  }

  const redirectToThirdParty = async (redirectUri, code) => {
    if (typeof window !== undefined && window.location && redirectUri) {
      window.location.href = redirectUri + (code ? `?code=${code}` : '')
    }
  }

  const redirectIfLoggedIn = async credentials => {
    const { redirectUri, responseType, clientId } = credentials
    const token = await getSSOData()
    let isTokenValid = false

    if (token) {
      const { accessToken } = token
      isTokenValid = await doVerifyToken(accessToken)
    }

    if (isTokenValid) {
      const responseTypes = ['code', 'custom']
      if (responseTypes.some(type => type === responseType)) {
        const redirectCode = await doRequestSSOCode({
          accessToken: token && token.accessToken,
          clientId,
        })
        await redirectToThirdParty(redirectUri, redirectCode)
      } else {
        setErrorMessage('Invalid response type')
      }
    } else {
      if (token) {
        // delete token, if token is exsisting but is invalid
        await deleteSSOData()
        await deleteAccessToken()
      }
      await redirectToLogin(credentials)
    }
  }

  React.useEffect(() => {
    const credentials = getCredentials(location.search)
    if (
      !location.search ||
      !credentials.redirectUri ||
      !credentials.clientId ||
      !credentials.responseType
    ) {
      setLoading(false)
      setErrorMessage('Missing credentials')
    } else {
      doVerifyClient({
        credentials,
        redirectToLogin,
        setLoading,
        setErrorMessage,
        redirectIfLoggedIn,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])

  return (
    <Layout minHeight="300px" variant="sso">
      <FlexWrapper>
        {loading ? (
          <>
            <Title> Please Wait...</Title>
            <SpinnerContainer>
              <Spinner />
            </SpinnerContainer>
          </>
        ) : (
          errorMessage && (
            <>
              <Title> Error</Title>
              <ErrorContainer>
                <ErrorMessage>{errorMessage}</ErrorMessage>
              </ErrorContainer>
            </>
          )
        )}
      </FlexWrapper>
    </Layout>
  )
}

export default MainView
